import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { faRecordVinyl } from '@fortawesome/pro-light-svg-icons/faRecordVinyl';
import { TypedMemo } from '../../../../common/types';
import { useSMLRouter } from '../../../../../routing/sml/hooks';
import { SMLRoutes } from '../../../../../routing/sml/SMLRoutes';
import { SMLEmptyState } from '../../../components/SMLEmptyState/SMLEmptyState';
import { Panel } from '../../../components/primitives/Panel';
import { releaseListMessages } from './releaseListMessages';

/**
 * The catalog is empty (design a2). "Add a song" opens the Catalog, where the add flow (an
 * unreleased song or a claim) lives. A member sees the same buttons.
 */
const ReleasesEmptyComponent: React.FC = () => {
  const intl = useIntl();
  const router = useSMLRouter();
  const openCatalog = useCallback(() => router.push(SMLRoutes.catalog), [router]);

  return (
    <Panel>
      <SMLEmptyState
        icon={faRecordVinyl}
        title={intl.formatMessage(releaseListMessages.emptyTitle)}
        description={intl.formatMessage(releaseListMessages.emptyBody)}
        action={{ label: intl.formatMessage(releaseListMessages.emptyAdd), onClick: openCatalog }}
      />
    </Panel>
  );
};

export const ReleasesEmpty = TypedMemo(ReleasesEmptyComponent);
